'use client'

import { cn } from '@/core/lib/utils/cn'
import { Accordion, AccordionItem } from '@/core/ui/atoms/accordion'
import { Skeleton } from '@/core/ui/atoms/skeleton'
import { useTranslations } from 'next-intl'

export default function FaqsListSkeleton() {
  const t = useTranslations()
  return (
    <section aria-label={t('ariaLabels.faq')} className='mb-10'>
      <h1 className='mb-9 text-2xl font-medium'>{t('faq.title')}</h1>

      <Accordion>
        {Array.from({ length: 3 }).map((_, index) => (
          <AccordionItem
            key={index}
            aria-label='Loading FAQ'
            title={
              <Skeleton height='32px' width='90%' borderRadius='0.375rem' />
            }
            classNames={{
              heading: cn('text-navy'),
              base: 'text-navy',
            }}
          >
            <div className='space-y-2'>
              <Skeleton height='16px' borderRadius='0.375rem' />
              <Skeleton height='16px' width='95%' borderRadius='0.375rem' />
              <Skeleton height='16px' width='80%' borderRadius='0.375rem' />
            </div>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  )
}
